/** @deprecated Skapa has a boolean called "small". Use this to set "medium" or "small" size for buttons. */
enum ButtonSizeEnum {
	small = 'small',
	medium = 'medium'
}
export default ButtonSizeEnum;
